// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

/* animation */

sf-dancing-dots {
  display: inline-block;
  white-space: no-wrap;
}

sf-dancing-dots .sf-dots .sf-dot {
  display: inline-block;
  animation: wave 0.2s linear infinite;
}

sf-dancing-dots .sf-dots > .sf-dot:nth-child(2) {
  animation-delay: -0.0666s;
}

sf-dancing-dots .sf-dots > .sf-dot:nth-child(3) {
  animation-delay: -0.1333s;
}

@keyframes wave {
  0%,
  100% {
    transform: initial;
  }
  50% {
    transform: translateY(-0.4em);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DancingDots.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF,cAAc;;AAEd;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\n/* animation */\n\nsf-dancing-dots {\n  display: inline-block;\n  white-space: no-wrap;\n}\n\nsf-dancing-dots .sf-dots .sf-dot {\n  display: inline-block;\n  animation: wave 0.2s linear infinite;\n}\n\nsf-dancing-dots .sf-dots > .sf-dot:nth-child(2) {\n  animation-delay: -0.0666s;\n}\n\nsf-dancing-dots .sf-dots > .sf-dot:nth-child(3) {\n  animation-delay: -0.1333s;\n}\n\n@keyframes wave {\n  0%,\n  100% {\n    transform: initial;\n  }\n  50% {\n    transform: translateY(-0.4em);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
